import { Nullable } from '../../types/common'
import { debounce } from '../../utils/debounce'
import BaseComponent from '../base-component/base-component'

class ScrollingText extends BaseComponent {
  lineSelector: string
  containerSelector: string
  resizeObserver: ResizeObserver
  paddings: number
  container: Nullable<HTMLElement>
  styles: CSSStyleDeclaration

  constructor() {
    super()

    this.containerSelector = '[data-scrolling-text-container]'
    this.lineSelector = 'scrolling-text-line'

    this.container = this.querySelector(this.containerSelector)

    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(this.container)

    this.styles = getComputedStyle(this.container)
  }

  disconnectedCallback(): void {
    this.resizeObserver.disconnect()
  }

  calcHeight = (): number => {
    this.paddings =
      parseInt(this.styles.paddingTop) + parseInt(this.styles.paddingBottom)

    const lines = this.querySelectorAll(this.lineSelector)
    let heightToSet: number

    const firstLineRect = lines[0].getBoundingClientRect()

    if (lines.length > 1) {
      const coordsTop: number[] = []
      const coordsBottom: number[] = []

      const lastLineRect = lines[lines.length - 1].getBoundingClientRect()

      coordsTop.push(firstLineRect.top)
      coordsTop.push(lastLineRect.top)
      coordsBottom.push(firstLineRect.bottom)
      coordsBottom.push(lastLineRect.bottom)

      heightToSet =
        coordsBottom.sort((a, b) => b - a)[0] -
        coordsTop.sort((a, b) => a - b)[0]
    } else {
      heightToSet = firstLineRect.height
    }

    return heightToSet
  }

  setHeight = (): void => {
    const height = this.calcHeight()

    this.style.setProperty('--gsc-section-height', `${height}px`)
  }

  handleResize = debounce((): void => {
    this.setHeight()
  }, 100)
}

export default ScrollingText
